module.exports = __webpack_public_path__ + "img/stars.6d629265.png";